export default __webpack_public_path__ + "static/media/SpinnerCircle.f927a181.svg";